import TabletAPI from 'api/tablet.api';
import { updateLoadingState } from 'store/app.slice';
import {
  setUnassociatedTabletList,
  setAllTablets,
  updateUnassociatedTabletList,
} from 'store/tablet.slice';
import { type IUpdateTabletPayload } from 'types/payloads/tablet.payload.types';
import AssetHandler from './asset.handler';
import { BaseHandler } from './base.handler';

export default class TabletHandler extends BaseHandler {
  private readonly api: TabletAPI;
  private readonly assetHandler: AssetHandler;

  constructor() {
    super();
    this.api = new TabletAPI();
    this.assetHandler = new AssetHandler();
  }

  async getAll(): Promise<void> {
    this.dispatch(updateLoadingState(true));
    try {
      const [all, unassociated] = await Promise.all([
        this.api.getAllTablets(),
        this.api.unassociatedTabletGetAll(),
      ]);
      this.dispatch(setAllTablets(all));
      this.dispatch(setUnassociatedTabletList(unassociated));
      this.dispatch(updateLoadingState(false));
    } catch (_) {
      this.handleError('An error occurred while fetching tablets.');
      this.dispatch(updateLoadingState(false));
    }
  }

  async updateTablet(
    tabletId: string,
    payload: IUpdateTabletPayload
  ): Promise<void> {
    this.dispatch(updateLoadingState(true));
    try {
      const updatedTablet = await this.api.update(tabletId, payload);

      void this.assetHandler.getAll();
      this.dispatch(updateUnassociatedTabletList(updatedTablet));

      this.handleSuccess('Tablet has been updated.');
      this.dispatch(updateLoadingState(false));
    } catch (_) {
      this.handleError('An error occurred while updating the tablet.');
      this.dispatch(updateLoadingState(false));
    }
  }
}
